import { render, staticRenderFns } from "./BotoesAcoes.vue?vue&type=template&id=6be43e9a"
import script from "./BotoesAcoes.vue?vue&type=script&lang=js"
export * from "./BotoesAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports